import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
import React from 'react';
import styled from 'styled-components';
import { TABLET, MOBILE } from '../../../constants';
import Button from '../../../elements/Button';
import AppLink from '../../../elements/AppLink';
import ExternalLinkEl from '../../../elements/ExternalLink';
var Overlay = styled.div.withConfig({
  displayName: "MobileNavBarstyles__Overlay",
  componentId: "pantheon__sc-3b9t9i-0"
})(["position:fixed;right:0;top:0;height:100vh;width:100vw;z-index:1000;background:rgba(0,0,0,0.4);"]);
var Menu = styled.div.withConfig({
  displayName: "MobileNavBarstyles__Menu",
  componentId: "pantheon__sc-3b9t9i-1"
})(["position:fixed;flex-grow:0;right:0;top:0;transition:500ms ease;height:100%;width:65%;z-index:1001;background-color:", ";display:flex;flex-direction:column;align-items:flex-start;transform:translateX(", ");opacity:", ";@media (max-width:", "){width:100%;}"], function (props) {
  return props.menuColor || 'black';
}, function (props) {
  return props.open ? "0" : "100%";
}, function (props) {
  return props.open ? "" : "0";
}, MOBILE);
var MenuContainer = styled.div.withConfig({
  displayName: "MobileNavBarstyles__MenuContainer",
  componentId: "pantheon__sc-3b9t9i-2"
})(["display:none;@media (max-width:", "){display:flex;margin-right:2rem;}"], TABLET);
var MenuSubscribeButton = styled(Button).withConfig({
  displayName: "MobileNavBarstyles__MenuSubscribeButton",
  componentId: "pantheon__sc-3b9t9i-3"
})(["margin:2.5rem 0 0 1rem;"]);
var LinksContainer = styled.div.withConfig({
  displayName: "MobileNavBarstyles__LinksContainer",
  componentId: "pantheon__sc-3b9t9i-4"
})(["width:100%;display:flex;flex-direction:column;"]);
var MenuLink = styled(function (_ref) {
  var menuDividerColor = _ref.menuDividerColor,
      menuItemColor = _ref.menuItemColor,
      mobileHoverState = _ref.mobileHoverState,
      rest = _objectWithoutPropertiesLoose(_ref, ["menuDividerColor", "menuItemColor", "mobileHoverState"]);

  return /*#__PURE__*/React.createElement(AppLink, rest);
}).withConfig({
  displayName: "MobileNavBarstyles__MenuLink",
  componentId: "pantheon__sc-3b9t9i-5"
})(["transition:500ms;height:5rem;font-weight:300;width:calc(100% - 2rem);margin:0 auto;color:", ";border-bottom:1px solid ", ";display:flex;align-items:center;&:hover{", ";}&:first-child{margin-top:5rem;}&:last-child{border:none;}", ";"], function (props) {
  return props.menuItemColor || "white";
}, function (props) {
  return props.menuDividerColor || props.menuItemColor;
}, function (props) {
  return props.mobileHoverState || "font-weight: 600";
}, function (props) {
  return props.selected ? props.mobileHoverState || "font-weight: 600" : "";
});
var ExternalMenuLink = styled(function (_ref2) {
  var menuDividerColor = _ref2.menuDividerColor,
      menuItemColor = _ref2.menuItemColor,
      mobileHoverState = _ref2.mobileHoverState,
      rest = _objectWithoutPropertiesLoose(_ref2, ["menuDividerColor", "menuItemColor", "mobileHoverState"]);

  return /*#__PURE__*/React.createElement(ExternalLinkEl, rest);
}).withConfig({
  displayName: "MobileNavBarstyles__ExternalMenuLink",
  componentId: "pantheon__sc-3b9t9i-6"
})(["transition:500ms;height:5rem;font-weight:300;width:calc(100% - 2rem);margin:0 auto;color:", ";border-bottom:1px solid ", ";display:flex;align-items:center;&:hover{", ";}&:first-child{margin-top:5rem;}&:last-child{border:none;}", ";"], function (props) {
  return props.menuItemColor || "white";
}, function (props) {
  return props.menuDividerColor || props.menuItemColor;
}, function (props) {
  return props.mobileHoverState || "font-weight: 600";
}, function (props) {
  return props.selected ? props.mobileHoverState || "font-weight: 600" : "";
});
export { MenuContainer, Menu, MenuSubscribeButton, MenuLink, LinksContainer, ExternalMenuLink, Overlay };